import React, { useState } from "react";
import { ModalBuilder, Modal } from "@redriver/cinnamon";
import InitialScheduleTermForm from "./InitialScheduleTermForm";

const EditInitialScheduleTermModal = ({
  itemId,
  dealerId,
  onUpdated,
  reference,
  getAction,
  updateAction,
  title,
  ...props
}) => {
  const apiParams = { dealerId, itemId };
  const [uploadDoc, setUploadDoc] = useState(null);

  const onChangeUpload = (file) => {
    let fileReader = new FileReader();
    fileReader.onload = () => {
      const res = fileReader.result;
      setUploadDoc(res);
    };
    fileReader.readAsDataURL(file);
  };

  return (
    <ModalBuilder
      withForm
      loadAction={getAction}
      loadParams={apiParams}
      submitAction={updateAction}
      submitParams={{ dealerId, itemId, uploadDoc }}
      onSubmitted={onUpdated}
      renderTrigger={(showModal) => (
        <div {...props} onClick={showModal} className="item">
          Edit
        </div>
      )}
      renderModal={(modalProps, formProps) => (
        <Modal.Edit
          {...modalProps}
          header={`${title}: ${reference}`}
          submitLabel="Update"
        >
          <InitialScheduleTermForm
            {...formProps}
            onChangeUpload={onChangeUpload}
            editMode={true}
          />
        </Modal.Edit>
      )}
    />
  );
};

export default EditInitialScheduleTermModal;
